import { DialogComponent, DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';

/**
 * `<video-dialog-component>` — a DialogComponent whose dialog contains a
 * `ref="video"` element. Opening restarts and plays the video, closing
 * pauses it. Reusable for any section with a video popup.
 *
 * @extends {DialogComponent}
 */
class VideoDialogComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogOpenEvent.eventName, this.#playVideo);
    this.addEventListener(DialogCloseEvent.eventName, this.#pauseVideo);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(DialogOpenEvent.eventName, this.#playVideo);
    this.removeEventListener(DialogCloseEvent.eventName, this.#pauseVideo);
  }

  #playVideo = () => {
    const { video } = this.refs;
    if (!(video instanceof HTMLVideoElement)) return;

    video.currentTime = 0;
    video.play();
  };

  #pauseVideo = () => {
    const { video } = this.refs;
    if (!(video instanceof HTMLVideoElement)) return;

    video.pause();
  };
}

if (!customElements.get('video-dialog-component')) {
  customElements.define('video-dialog-component', VideoDialogComponent);
}
